import axios from 'axios';
import LocalAuth from '@shamrock-core/common/authentication/local-authentication';

export const getToken: any = () => {
  const token = window.localStorage.getItem(LocalAuth.TOKEN_KEY);
  if (token) {
    const json = JSON.parse(token);
    return json.token;
  }
  return null;
};

export const getDefaultConfig = async () => {
  const token = await getToken();
  return {
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
      'Content-Type': 'application/json',
    },
  };
};

const get =
  <T extends unknown, Q extends unknown>(url: string) =>
  async (query?: Q) =>
    axios.get<T>(url, { ...(await getDefaultConfig()), params: query });

const post =
  <T extends unknown, B extends unknown>(url: string) =>
  async (body?: B) =>
    axios.post<T>(url, body, { ...(await getDefaultConfig()) });

const put =
  <T extends unknown, B extends unknown>(url: string) =>
  async (body?: B) =>
    axios.put<T>(url, body, { ...(await getDefaultConfig()) });

const patch =
  <T extends unknown, B extends unknown>(url: string) =>
  async (body?: B) =>
    axios.patch<T>(url, body, { ...(await getDefaultConfig()) });

const doDelete =
  <T extends unknown, Q extends unknown>(url: string) =>
  async (query?: Q) =>
    axios.delete<T>(url, { ...(await getDefaultConfig()), params: query });

const http = { get, put, post, patch, delete: doDelete };

export default http;
